<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <div class="box">
          <div class="box-header">
            <h3 class="box-title">{{storeName}}排程列表</h3>
          </div>
          <!-- /.box-header -->
          <div class="box-body">
            <div class="row form-inline">
              <div class="col-sm-6 text-left form-group">
                <router-link :to="{path: '/crSchedule'}">
                  <div class="btn btn-default btn-table-title">新增排程</div>
                </router-link>
              </div>
            </div>
            <div class="col-xs-12">
              <!--<div class="gantt"></div>-->
              <!--<div class="menu-info"></div>-->
              <store-schedule-list></store-schedule-list>
            </div>
          </div>
        </div>
      </div>
    </div>
    <router-view ></router-view>
  </section>
</template>

<script>
import $ from 'jquery'
import moment from 'moment'
// Require needed datatables modules
import 'datatables.net'
import 'datatables.net-bs'
import storeListTemp from './Temp/StoreListTemp.vue'
import Multiselect from 'vue-multiselect'
import '../../../../static/vendor/Gantt/1.10.2/css/style.css'
import '../../../../static/vendor/Gantt/1.10.2/js/jquery.fn.gantt.js'
import storeScheduleListTemp from './Temp/StoreScheduleListTemp.vue'
/*
import '../../../../static/vendor/ganttView/0.8.8/lib/date.js'
import 'jquery-ui'
import '../../../../static/vendor/ganttView/0.8.8/jquery.ganttView.js'
import '../../../../static/vendor/ganttView/0.8.8/jquery.ganttView.css'
*/

export default {
  components: {
    'storelist-table': storeListTemp,
    'store-schedule-list': storeScheduleListTemp,
    Multiselect
  },
  data () {
    return {
      storeName: '',
      menuState: 4,
      name: '迷客夏',
      total: 1,
      count: 20,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      info: {
        menuName: '夏日菜單',
        menu_id: 123323,
        start_time: '2017-03-31 12:22:32',
        end_time: '2017-03-31 12:22:32',
        update_time: '2017-03-31 12:22:32',
        create_time: '2017-03-31 12:22:32'
      },
      menu_schedule_list: [
        {
          'schedule_id': 122,
          'store_id': 1,
          'store_name': '金山店',
          'menu_id': 1,
          'start_time': '2017-04-24 08:00:00',
          'end_time': '2017-06-01 00:00:00',
          'status': 1,
          'update_time': '2017-01-14 16:09:16',
          'create_time': '2017-01-14 16:09:16'
        },
        {
          'schedule_id': 123,
          'store_id': 2,
          'store_name': '民權店',
          'menu_id': 2,
          'start_time': '2017-04-24 08:00:00',
          'end_time': '2017-06-01 00:00:00',
          'status': 1,
          'update_time': '2017-01-14 16:09:16',
          'create_time': '2017-01-14 16:09:16'
        },
        {
          'schedule_id': 124,
          'store_id': 3,
          'store_name': '中山店',
          'menu_id': 1,
          'start_time': '2017-04-24 08:00:00',
          'end_time': '2017-06-01 00:00:00',
          'status': 1,
          'update_time': '2017-01-14 16:09:16',
          'create_time': '2017-01-14 16:09:16'
        }
      ],
      test: [
        {
          id: 1,
          name: 'Feature 1',
          series: [
            { start: new Date('2010,05,01'), end: new Date('2010,05,03'), menu_id: '1' }
          ]
        },
        {
          id: 2,
          name: 'Feature 2',
          series: [
            { start: new Date('2010,06,05'), end: new Date('2010,06,20'), menu_id: '2' }
          ]
        }
      ],
      scheduleList: []
    }
  },
  mounted () {
    this.$nextTick(() => {
      $('#example1_wrapper').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      })
    })
  },
  methods: {
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    editStores (menuId) {
      this.$router.push('/upSchedule/all/' + menuId)
    },
    clickPage (index) {
      this.tableIndex = index
      this.getScheduleList()
    },
    getScheduleList () {
      var self = this
      var brandId = this.$route.params.brand_id
      var data = {
        page: this.tableIndex,
        size: this.count
      }
      var url = '/brand/' + brandId + '/menu/schedule/list?page=' + data.page + '&size=' + data.size + '&sortby=start_time DESC' + '&store_id=' + this.$route.params.store_id + '&status=' + this.menuState
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.total = response.data.meta.total
          console.log(self.total)
          const sList = response.data.menu_schedule_list
          let newSList = []
          let storeIdList = {}
          for (let i = 0; i < sList.length; i++) {
            self.storeName = sList[i].store_name
            const data = {
              name: sList[i].menu_name,
              desc: '',
              store_id: sList[i].store_id,
              values: [{
                from: '/Date(' + moment(sList[i].start_time, 'YYYY-MM-DD HH:mm:ss') + ')/',
                to: '/Date(' + moment(sList[i].end_time, 'YYYY-MM-DD HH:mm:ss') + ')/',
                label: '',
                desc: sList[i].store_name,
                dataObj: sList[i]
              }]
            }
            newSList.push(data)
            if (!storeIdList[sList[i].store_id]) storeIdList[sList[i].store_id] = []
            storeIdList[sList[i].store_id].push(data)
          }
          self.scheduleList = newSList
          self.checkDoubleStore(storeIdList)
        }
      })
    },
    checkDoubleStore (storeIdList) {
      console.log(storeIdList)
      var newScheduleList = []
      for (let key in storeIdList) {
        /*
        if (storeIdList[key].length === 1) {
          newScheduleList.push(storeIdList[key][0])
        } else {
          var combineSchedule = {}
          for (let i = 0; i < storeIdList[key].length; i++) {
            if (i === 0) {
              combineSchedule = storeIdList[key][i]
            } else {
              combineSchedule.values.push(storeIdList[key][i].values[0])
            }
          }
          newScheduleList.push(combineSchedule)
        }
        */
        newScheduleList.push(storeIdList[key][0])
      }
      console.log(newScheduleList)
      this.setGantt(newScheduleList)
    },
    setGantt (scheduleList) {
      if (scheduleList.length) {
        $('.gantt').gantt({
          source: scheduleList,
          scale: 'months',
          minScale: 'months',
          navigate: 'scroll',
          waitText: '正在讀取菜單排程...',
          itemsPerPage: 12
        })
        $('.gantt').css('display', 'block')
        $('menu-info').css('display', 'block')
      } else {
        $('.gantt').css('display', 'none')
        $('menu-info').css('display', 'none')
      }
    },
    pageShow (index) {
      var num = index / this.groupAmount
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true
      else return false
    }
  },
  computed: {
    scheduleListNew () {
      var menuList = {}
      var oldList = this.menu_schedule_list
      for (var key in oldList) {
        // console.log(oldList[key].menu_id)
        menuList[oldList[key].menu_id] = {
          menu_id: oldList[key].menu_id,
          storeList: []
        }
      }
      for (var k in oldList) {
        menuList[oldList[k].menu_id].storeList.push({
          store_id: oldList[k].store_id,
          store_name: oldList[k].store_name,
          start_time: oldList[k].start_time,
          end_time: oldList[k].end_time,
          status: oldList[k].status,
          update_time: oldList[k].update_time,
          create_time: oldList[k].create_time,
          schedule_id: oldList[k].schedule_id,
          menu_id: oldList[key].menu_id
        })
      }
      return menuList
    },
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    }
  },
  watch: {
    menuState () {
      this.tableIndex = 1
      this.pageGroup = 1
      this.getScheduleList()
    }
  },
  created () {
    this.getScheduleList()
  }
}
</script>
<style lang="sass">
.menu-info
  min-height: 120px
  width: 100%
  text-align: center
  *
    padding: 0
    margin: 0
    line-height: 25px
.m-b-15
  margin-bottom: 15px !important
.btn-edit-all, .btn-del-all
  margin-right: 15px
  z-index: 100
.nav-page-back, .page-number, .nav-page-next, .nav-zoomIn, .nav-zoomOut
  display: none !important
.fn-gantt .leftPanel
  width: 100px !important
.fn-gantt .leftPanel .fn-wide, .fn-gantt .leftPanel .fn-wide .fn-label
  font-size: 14px
.fn-gantt .navigate
  padding: 10px 0 10px 10px !important
@media screen and (max-width: 499px)
  .min-m-t-10
    margin-top: 25px
</style>



// WEBPACK FOOTER //
// StoreScheduleTable.vue?3916b4f4